module.exports = __webpack_public_path__ + "static/img/logo-calq.f9ed7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/img/logo-calq.png
// module id = kUVl
// module chunks = 0